module.exports = __webpack_public_path__ + "static/media/AWS_contentsPage_en.6d445897.png";